import { render, staticRenderFns } from "./PosInvoicesTaxRefundDetail.vue?vue&type=template&id=d17d652a&scoped=true&"
import script from "./PosInvoicesTaxRefundDetail.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTaxRefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17d652a",
  null
  
)

export default component.exports